import { addRoom, deleteRoom } from '../../redux/currentSearch/actions';

export const synchronizeRooms = ({ currentSearchRedux, currentAccommodationSearch }, dispatch) => {
    currentSearchRedux.rooms.forEach((room, index) => {
        dispatch(deleteRoom(currentSearchRedux.rooms[index]));
    });
    currentAccommodationSearch.rooms.forEach((room) => {
        dispatch(addRoom(room));
    });
};

